import {z} from "zod/v4-mini"
import type {FundamentalLikeNode} from "#template/role-markers"
import {createFundamentalMarker} from "#template/role-markers"

export const booleanLikeMarker = Symbol("BooleanLike")

export interface BooleanLikeNode extends FundamentalLikeNode<boolean | null> {
    readonly [booleanLikeMarker]: true
}

export const booleanMarker = createFundamentalMarker<BooleanLikeNode, boolean>(booleanLikeMarker, {
    rawSchema: z.boolean(),
    acceptsRaw: (x): x is boolean => typeof x === "boolean",
})
export const {
    isLikeNode: isBooleanLikeNode,
    isLikeNodeClass: isBooleanLikeNodeClass,
    likeNode: booleanLikeNode,
    isLike: isBooleanLike,
    like: booleanLike,
} = booleanMarker
export type BooleanLike = z.infer<typeof booleanLike>
